import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo, useState } from "react";
import "./detail.scss";

import {
  CloseOutlined,
  CloudDownloadOutlined,
  DeleteOutlined,
  FontColorsOutlined,
  LayoutOutlined,
  PlusOutlined,
  SaveOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  ConfigProvider,
  Modal,
  Space,
  Tooltip,
  Typography,
} from "antd";
import {
  useSurveyDetail,
  useSurveyInfo,
} from "../../../../../../stores/stores";
import { useParams } from "react-router-dom";
import { ListQuestion } from "../../../../../../types/survey-managment/survey";

import DrawerCustom from "../../../../../../components/drawer/Drawer";
import SurveyQuestionSuggestion from "../survey-question-suggestion/SurveyQuestionSuggestion";
import {
  MoocSurveyContentQuestion,
} from "../../../../../../types/survey-managment/mooc-survey-content";
import { ListSurveySection } from "../../../../../../types/survey-managment/survey";

interface RightControlProps {
  handleShowFilterQuestion?: () => void;
  surveyDescriptionContent: string;
  chooseQuestionFromCloud?: () => {};
  addNewQuestion?: (sectionNumber: number) => void;
  addNewSection?: (sectionNumber: number) => void;
  addQuestionFromCloud?: (
    sectionNumber: number,
    newQuestion?: ListQuestion
  ) => void;
  listQuestionAddMore?: MoocSurveyContentQuestion[] | [];
  setListQuestionAddMore?: React.Dispatch<
    React.SetStateAction<MoocSurveyContentQuestion[]>
  >;
  dataSection?: any;
  setUpdateDataSection?: (data: ListSurveySection[]) => void;
  setDataSection?: any;
  isShowSurveyDescription?: boolean;
  setIsShowSurveyDescription?: (data: boolean) => void;
  handleAddMoreQuestionExist?: any;
  topValueQuestionActive?: number;
  handleDeleteAllSectionsKeepQuestions?: any;
}

const RightControl: React.FC<RightControlProps> = ({
  handleShowFilterQuestion,
  surveyDescriptionContent,
  chooseQuestionFromCloud,
  addNewQuestion,
  addNewSection,
  addQuestionFromCloud,
  listQuestionAddMore,
  setListQuestionAddMore,
  dataSection,
  setDataSection,
  isShowSurveyDescription,
  setIsShowSurveyDescription,
  setUpdateDataSection,
  handleAddMoreQuestionExist,
  topValueQuestionActive,
  handleDeleteAllSectionsKeepQuestions,
}) => {
  const { t } = useTranslation();
  const updateSurveyDescription = useSurveyInfo(
    (state) => state?.updateSurveyDescription
  );

  const topValueActive = useMemo(()=>{ 

    if(topValueQuestionActive){
      if(dataSection && dataSection.length===1 && topValueQuestionActive<300) {return topValueQuestionActive>0?(topValueQuestionActive+100) : 300} 
      if(topValueQuestionActive<0) return 300
      if(topValueQuestionActive>0 && topValueQuestionActive<=168){return 120} 
      if(topValueQuestionActive>0 && topValueQuestionActive>168 && topValueQuestionActive <=500) {return (topValueQuestionActive)}
      if (topValueQuestionActive > 500) {
        return 300;
      }
    }
    return 300
}, [topValueQuestionActive]);
  
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const [surveyDescription, setSurveyDescription] = useState(
    surveyDescriptionContent
  );
  const [listSurveyQuestionSuggestion, setListSurveyQuestionSuggestion] =
    useState();

  const listSurveySections = useSurveyDetail(
    (state) => state.listSurveySections
  );
  const [selectedSectionIndex, setSelectedSectionIndex] = useState(-1);

  const param = useParams();
  const handleUpdateSurveyDescription = async () => {
    updateSurveyDescription(Number(param.id), surveyDescription);
  };

  //icon PlusOutlined
  const handleAddQuestion = () => {
    if (addNewQuestion) {
      addNewQuestion(topValueQuestionActive || 220);
    }
  };

  //icon CloudOutlined
  const [isShowModalAddQuestionCloud, setIsShowModalAddQuestionCloud] =
    useState(false);

  const handleShowModalAddQuestionCloud = () => {
    setIsShowModalAddQuestionCloud(true);
  };

  const handleCancelAddQuestionCloud = () => {
    setIsShowModalAddQuestionCloud(false);
  };

  const handleAddQuestionCloud = () => {
    if (addQuestionFromCloud) {
      addQuestionFromCloud(selectedSectionIndex);
    }
    setIsShowModalAddQuestionCloud(false);
  };

  // icon LayoutOutlined
  const handleAddSection = () => {
    if (addNewSection) {
      addNewSection(selectedSectionIndex);
    }
  };

  const [isOpenCloudQuestion, setIsOpenCloudQuestion] = useState(false);
  const [selectedItems, setSelectedItems] = useState<
    MoocSurveyContentQuestion[]
  >([]);

  const handleAddMoreQuestion = () => {
    const newData = selectedItems.map((section) => {
      return {
        ...section,
        moocSurvey_question_answer:
          section &&
          section.moocSurveyQuestionAnswer &&
          section?.moocSurveyQuestionAnswer.map(
            ({ id, surveyQuestionId, ...rest }) => {
              return {
                ...rest,
              };
            }
          ),
      };
    });
    handleAddMoreQuestionExist(newData);

    setIsOpenCloudQuestion(false);
    setSelectedItems([]);
    setIsChecked(false);
  };

  const handleExitAddMoreQuestionExsit = () => {
    setIsOpenCloudQuestion(false);
    setSelectedItems([]);
    setIsChecked(false);
  };
  const showConfirmDeleteSections = () => {
    Modal.confirm({
      title: t("Xóa tất cả thành phần và giữ lại toàn bộ câu hỏi", "Xóa tất cả thành phần và giữ lại toàn bộ câu hỏi"),
      content: (
        <>
          {t("Bạn có chắc chắn muốn xóa tất cả thành phần và giữ lại toàn bộ câu hỏi?", "Bạn có chắc chắn muốn xóa tất cả thành phần và giữ lại toàn bộ câu hỏi?")}
        </>
      ),
      cancelText: t("Hủy bỏ", "Hủy bỏ"),
      okText: t("Xác nhận", "Xác nhận"),
      onOk: handleDeleteAllSectionsKeepQuestions,
      centered: true,
    });
  };

  return (
    <div className="survey-managment-right-control">
      <ConfigProvider
        theme={{
          components: {
            Tooltip: {
              colorTextLightSolid: "black",
              colorBgSpotlight: "white",
            },
          },
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end", position: "relative" }}
        >
          <div
            style={{
              marginRight: "-85px",
              position: "relative", 
              marginBottom: "12px"
            }}
          >
            <Space
              size="small"
              direction="vertical"
              style={{
                backgroundColor: "white",
                borderRadius: "10px",
                padding: "10px",
              }}
            >
              <Tooltip placement="top" title={t("Tìm kiếm câu hỏi trong khảo sát", "Tìm kiếm câu hỏi trong khảo sát")}>
                <Button
                  onClick={handleShowFilterQuestion}
                  icon={<SearchOutlined />}
                />
              </Tooltip>
            </Space>
          </div>
        </div>

        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end",position: "relative"  }}
        >
          <div id='right-control'
            style={
              topValueActive
                ? {
                    marginRight: "-85px",
                    position: "fixed", 
                    top: `${topValueActive}px`,
                    transition: "top 0.3s ease",
                  }
                : {
                    marginRight: "-85px",
                    position: "relative", 
                    top:"0",
                    marginTop:"12px",
                    transition: "top 0.3s ease",
                  }
            }
          >
            <Space
              size="small"
              direction="vertical"
              style={{
                backgroundColor: "white",
                borderRadius: "10px",
                padding: "10px",
              }}
            >
              <Tooltip placement="top" title={t("Thêm câu hỏi", "Thêm câu hỏi")}>
                <Button icon={<PlusOutlined />} onClick={handleAddQuestion} />
              </Tooltip>

              <Tooltip placement="top" title={t("Chọn câu hỏi sẵn có", "Chọn câu hỏi sẵn có")}>
                <Button
                  icon={<CloudDownloadOutlined />}
                  // onClick={handleShowModalAddQuestionCloud}
                  onClick={() => setIsOpenCloudQuestion(true)}
                />

                <DrawerCustom
                  title={t("Thêm mới từ danh sách câu hỏi sẵn có", "Thêm mới từ danh sách câu hỏi sẵn có")}
                  open={isOpenCloudQuestion}
                  onClose={() => {
                    setIsOpenCloudQuestion(false);
                  }}
                  extraNode={
                    <div>
                      <Space>
                        <Button
                          onClick={handleExitAddMoreQuestionExsit}
                          className="btn btn-outlined"
                        >
                          <CloseOutlined />
                          <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
                        </Button>
                        <Button
                          className="btn btn-primary"
                          htmlType="submit"
                          onClick={handleAddMoreQuestion}
                        >
                          <SaveOutlined />
                          <Typography.Text>{t("Chọn", "Chọn")}</Typography.Text>
                        </Button>
                      </Space>
                    </div>
                  }
                  widthDrawer={900}
                >
                  <SurveyQuestionSuggestion
                    isOpenCloudQuestion={isOpenCloudQuestion}
                    setIsOpenCloudQuestion={setIsOpenCloudQuestion}
                    setSelectedItems={setSelectedItems}
                    selectedItems={selectedItems}
                    isChecked={isChecked}
                    setIsChecked={setIsChecked}
                    setDataSection={setDataSection}
                    dataSection={dataSection}
                    handleExitAddMoreQuestionExsit={
                      handleExitAddMoreQuestionExsit
                    }
                  />
                </DrawerCustom>
              </Tooltip>

              <Tooltip placement="top" title={t("Thêm mô tả đợt KS", "Thêm mô tả đợt KS")}>
                <Button
                  icon={<FontColorsOutlined />}
                  onClick={() =>
                    setIsShowSurveyDescription &&
                    setIsShowSurveyDescription(true)
                  }
                  disabled={isShowSurveyDescription}
                />
              </Tooltip>

              <Tooltip placement="top" title={t("Thêm thành phần", "Thêm thành phần")}>
                <Button icon={<LayoutOutlined />} onClick={handleAddSection} />
              </Tooltip>

              <Tooltip
                placement="top"
                title={t("Xóa tất cả thành phần và giữ câu hỏi", "Xóa tất cả thành phần và giữ câu hỏi")}
              >
                <Button
                  icon={<DeleteOutlined />}
                  onClick={showConfirmDeleteSections}
                />
              </Tooltip>
            </Space>
          </div>
        </div>
      </ConfigProvider>
    </div>
  );
};

export default RightControl;
